<i18n lang='yml' src='../i18n/Table.yml'></i18n>
<template>
  <div>
    <span id='historyTableTitle' class="sr-only"> {{$t('history_of_events')}}</span>
    
    <div class="table-container" id="table-container-history" role="table" aria-describedby="historyTableTitle">
      
      <div class="flex-table-history"  :class="name ? `flex-table-history-${name}${columnNumber ? `-${columnNumber}` : ''}` :''" role="rowgroup">
        <div class="flex-row table-header" :class="column.key == 'notes'? 'flex-row-long' : ''" role="columnheader" :key="index" v-for="(column, index) in regularColumns()">{{column.name}}</div>
      </div>
      <template v-if="itemData.length > 0"> 
        <div class="fill-table" :class="name ? `flex-table-history-${name}${columnNumber ? `-${columnNumber}` : ''}` :''" :key="index" v-for="(item, index) in computedItems">
          <div class="flex-table-history" role="rowgroup" >  
            <div class="flex-row" :class="column.key == 'notes'? 'flex-row-long' : ''" role="cell" :key="index" v-for="(column, index) in regularColumns()">
              {{format(item[column.key], column.formatType)}}
            </div>
          </div>

          <div class="flex-table-history"  :class="name ? `flex-table-history-${name}` :''">
            <div class="flex-row-full" role="cell" :key="index" v-for="(column, index) in fullLengthColumns()">
              <span> 
                {{column.name}}: {{format(item[column.key], column.formatType)}}
              </span>
            </div>
          </div>
        </div>
      </template>
      <div v-else>
        <div class="flex-row-full">
          {{ $t('blank') }}
        </div>
    </div>
    </div>
    <pagination v-if="needsPagination"
      @items_changed="setItems" 
      :items="itemData" 
      :expansion_threshold="expansion_threshold" 
      :pagination_limit="pagination_limit" 
      :top_id="top_id"
    />
 
  </div>
</template>
<script>
import Pagination from '../../pagination/Pagination.vue';
import {formatDate} from '../../../shared/typescripts/dates.ts'
export default {
  
  // column_info should be an an array of objects which up to 4 keys: name, key, fullLength and formatType
  // name is the name of the column (i.e 'Change Made At')
  // key is the name of the key we should extract from the item object to show in this column (i.e 'created_at')
  // formatType should correspond to one of the potential formatting options listed in the format method
  props: ['locale', 'column_info', 'itemData', 'pagination_limit', 'top_id', 'needsPagination', 'name', 'columnNumber', 'expansion_threshold'],
  components: {
    'pagination': Pagination,
  },
  data() {
    return {
      items: [],
    }
  },
  
  computed: {
    computedItems() {
      return this.needsPagination ? this.items : this.itemData;
    }
  },
  methods: {
    format(data, formatType=null) {
      if(formatType == 'date') {
        return this.formatDate(data)
      }
      return data && data.length > 0 && data != 'null' ?  data : ''
    },
    //TODO: Revisit to standardize
    // Used for turning our system dates into a standard human readable format
    formatDate(dateString) {
      return formatDate(dateString)
    }, 
    regularColumns: function () {
      return this.column_info.filter((column) => {return !column.fullLength})
    },
    fullLengthColumns: function () {
      return this.column_info.filter((column) => {return column.fullLength})
    },
    setItems(items) {
      this.items = items
    }
  }
}
</script>
